import { eraseErrorMessage, checkRadioTextInput } from './common';

const RESERVATION_REMOTE = 1;

//通信処理関係
/**
 * 墓に入る対象のの追加
 * @param from
 * @param to
 * @param tombList
*/
const insertObjectTomb = (from: number, to: number, tombList: HTMLDivElement): void =>
{

    const fd = new FormData();
    fd.append('action', 'add_object_tomb');
    fd.append('from', (from+1).toString());
    fd.append('to', to.toString());
    fd.append('mode', 'application');

    fetch(url,
    {
        method: 'POST',
        body: fd
    }).then(response =>
    {
        return response.text();
    }).then(text =>
    {
        tombList.insertAdjacentHTML('beforeend', text);
    });

}

/**
 * カレンダーの表示
 * @param move
 * @param mode
 * @param year
 * @param month
 * @param add_days
*/
const showCalendarBody = (move: string, mode: string, year: number, month: number, add_days: number): void =>
{

    const fd = new FormData();
    fd.append('action', 'show_calendar_body');
    fd.append('mode', mode);
    fd.append('year', year.toString());
    fd.append('month', month.toString());
    fd.append('move', move.toString());
    fd.append('add_days', add_days.toString());

    fetch(url,
    {
        method: 'POST',
        body: fd
    }).then(response =>
    {
        return response.text();
    }).then(text =>
    {
        const calendarBody = document.getElementById('calendar-body') as HTMLTableSectionElement;
        calendarBody.innerHTML = text;
        initCalendarDays();
    });

}

/**
 * カレンダーの年月の表示
 * @param move
 * @param mode
 * @param year
 * @param month
 * @param add_days
*/
const showCalendarYM = (move: string, mode: string, year: number, month: number, add_days: number): void =>
{

    const fd = new FormData();
    fd.append('action', 'show_calendar_ym');
    fd.append('mode', mode);
    fd.append('year', year.toString());
    fd.append('month', month.toString());
    fd.append('move', move.toString());
    fd.append('add_days', add_days.toString());

    fetch(url, {
        method: 'POST',
        body: fd
    }).then(response =>
    {
        return response.json();
    }).then(data =>
    {
        const calendarYear = document.getElementById('calendar-year') as HTMLSpanElement;
        const calendarMonth = document.getElementById('calendar-month') as HTMLSpanElement;
        calendarYear.innerHTML = data.year;
        calendarMonth.innerHTML = data.month;
    });

}

/**
 * 予約時間の取得
 * @param fd
*/
const getReservationTime = (fd: FormData): void =>
{

    fd.append('action', 'get_reservation_time');

    fetch(url,
    {
        method: 'POST',
        body: fd
    }).then(response => {
        return response.json();
    }).then(data => {

        initReservationTime(data);
        showTimeModal();

    });

}

/**
 * 予約情報の取得
 * @param fd
*/
const getReservationInfo = (fd: FormData): void =>
{

    fd.append('action', 'get_reservation_info');

    fetch(url,
    {
        method: 'POST',
        body: fd
    }).then(response => {
        return response.text();
    }).then(data => {

        const reservationTime = document.getElementById('j-reservation-info') as HTMLTableElement;
        reservationTime.innerHTML = data;

        showTimeModal();

    });

}

/**
 * 予約情報の保存
 * @param fd
*/
const sendServerToStore = (fd: FormData): void =>
{

    fd.delete('action');
    fd.append('action', 'submit_application');

    fetch(url, {
        method: 'POST',
        body: fd
    }).then(response => {
        return response.text();
    }).then(data => {

        const form = document.getElementById('j-form') as HTMLFormElement;
        form.remove();

        const message = document.getElementById('j-message') as HTMLDivElement;
        message.innerHTML = data;

    });

}

/**
 * フォームデータの作成
*/
const setFormData = (): FormData =>
{

    const fd = new FormData(document.querySelector('form') as HTMLFormElement);
    const individual_photo = document.querySelector('input[name="individual_photo"]') as HTMLInputElement;
    fd.append('individual_photo', individual_photo?.files?.[0] as File);

    const applicationTypes = document.querySelectorAll('input[name="application_type"]') as NodeListOf<HTMLInputElement>;
    if (applicationTypes !== null)
    {

        applicationTypes.forEach((applicationType, index) =>
        {

          if (applicationType.checked)
          {

            fd.append('application_type_index', index.toString());

          }

        });

    }

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType, index) =>
        {

          if (tombType.checked)
          {

            fd.append('tomb_type_index', index.toString());

          }

        });

    }

    const reservationTypes = document.querySelectorAll('input[name="reservation_type"]') as NodeListOf<HTMLInputElement>;
    if (reservationTypes !== null)
    {

        reservationTypes.forEach((reservationType, index) =>
        {

          if (reservationType.checked)
          {

            fd.append('reservation_type_index', index.toString());

          }

        });

    }

    return fd;

}

/**
 * 予約情報の確認
*/
const sendServerToCheck = (): void =>
{

    const fd = setFormData();
    fd.append('action', 'check_reservation');

    fetch(url, {
        method: 'POST',
        body: fd
    }).then(response => {
        return response.json();
    }).then(data => {

        if (data.result)
        {

            sendServerToStore(fd);

        }
        else
        {

            showErrorToBeUnavailable();
        }

    });

}

//初期化関係
/**
 * 墓に入る対象の数の初期化
*/
const initNumberOfObjects = (): void =>
{

    const numberOfObjects = document.getElementsByName('number_of_object') as NodeListOf<HTMLInputElement>;
    numberOfObjects.forEach((numberOfObject) =>
    {

        numberOfObject.addEventListener('change', () =>
        {

            const total_object = document.querySelector('input[name="total_object"]') as HTMLInputElement;
            const from: number = parseInt(total_object.value, 10) || 0;
            const to: number = parseInt(numberOfObject.dataset.count as string, 10);
            const tombList = document.getElementById('object-tomb-list') as HTMLDivElement;

            if (from < to)
            {

                insertObjectTomb(from, to, tombList);
            }
            else
            {

                for (let j = from; j > to; j--)
                {

                    tombList?.lastElementChild?.remove();

                }

            }

            total_object.value = to.toString();

        });

    });

}

/**
 * 予約時間の初期化
 * @param data
*/
const initReservationTime = (data: {[key: string]: number}): void =>
{

    let is_checked = false;
    const reservation_times = document.getElementsByName('reservation_time') as NodeListOf<HTMLInputElement>;

    reservation_times.forEach((reservation_time) =>
    {

        reservation_time.disabled = false;
        reservation_time.checked = false;

    });

    reservation_times.forEach((reservation_time) =>
    {

        Object.keys(data).forEach(key =>
        {

            if (reservation_time.value === key)
            {

                if (data[key] === 1)
                {

                    reservation_time.disabled = true;

                }
                else
                {
                    if (!is_checked)
                    {

                        reservation_time.checked = true;
                        is_checked = true;
                    }

                }

            }

        });

    });

}

/**
 * カレンダーでの日にち分の初期化
*/
const initCalendarDays = (): void =>
{

    const tds = document.querySelectorAll('#calendar-body td') as NodeListOf<HTMLTableCellElement>;
    tds.forEach((td) =>
    {

        td.addEventListener('click', () =>
        {

            const click = parseInt(td.dataset.click as string, 10);
            if (click === 1)
            {

                const calendarYear = document.getElementById('calendar-year') as HTMLSpanElement;
                const calendarMonth = document.getElementById('calendar-month') as HTMLSpanElement;

                const fd = new FormData();
                fd.append('mode', td.dataset.mode as string);
                fd.append('year', calendarYear.textContent as string);
                fd.append('month', calendarMonth.textContent as string);
                fd.append('day', td.dataset.day as string);

                const button = document.getElementById('j-button-time-decision') as HTMLButtonElement;
                if (button !== null)
                {

                    button.dataset.year = calendarYear.textContent as string;
                    button.dataset.month = calendarMonth.textContent as string;
                    button.dataset.day = td.dataset.day as string;

                }

                const reservationYear = document.getElementById('reservation-year') as HTMLSpanElement;
                const reservationMonth = document.getElementById('reservation-month') as HTMLSpanElement;
                const reservationDay = document.getElementById('reservation-day') as HTMLSpanElement;
                reservationYear.innerHTML = calendarYear.textContent as string;
                reservationMonth.innerHTML = calendarMonth.textContent as string;
                reservationDay.innerHTML = td.dataset.day as string;

                if (td.dataset.mode === 'application')
                {

                    getReservationTime(fd);

                }
                else
                {

                    getReservationInfo(fd);

                }

            }

        });

    });

}

/**
 * チェックボックスとセレクトの項目の初期化
*/
const initCheckboxSelectItems = (): void =>
{

    const item_name = [
        'buddhist_name1',
        'buddhist_name2',
        'buddhist_name3',
        'buddhist_name4',
        'buddhist_name5',
        'buddhist_name6',
        'buddhist_name7',
        'prenatal_application_human',
        'prenatal_application_pet',
        'pendant',
    ];

    item_name.forEach(key =>
    {

        const checkbox = document.querySelector('input[name="'+key+'"]') as HTMLInputElement;
        const select = document.querySelector('select[name="'+key+'_count"]') as HTMLSelectElement;

        if (checkbox !== null && checkbox.checked)
        {

            if (select !== null)
            {

                select.required = true;

            }

        }
        else
        {

            if (select !== null)
            {

                select.selectedIndex = 0;
                select.required = false;

            }

        }

    });

}

/**
 * ファイル入力のある項目の初期化
*/
const initFileInput = (): void =>
{

    const individualPhoto = document.getElementById('j-individual-photo') as HTMLLIElement;
    const file = document.querySelector('input[name="individual_photo"]') as HTMLInputElement;

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType, index) =>
        {

            tombType.addEventListener('change', () =>
            {

                if (tombType.checked)
                {

                    if (index === 0)
                    {

                        individualPhoto.classList.remove('u-display--none');
                        file.required = true;

                    }
                    else
                    {

                        individualPhoto.classList.add('u-display--none');
                        file.required = false;

                    }

                }

            });

        });

    }

    if (file !== null)
    {

      file.addEventListener('change', () =>
      {

        const explanation = document.getElementById('j-file-explanation') as HTMLSpanElement;
        explanation.classList.add('u-display--none');

      });

    }

}

/**
 * 予約種別の初期化
*/
const initReservationType = (): void =>
{

    const reservation_types = document.getElementsByName('reservation_type') as NodeListOf<HTMLInputElement>;
    reservation_types.forEach((reservation_type, index) =>
    {

        reservation_type.addEventListener('change', () =>
        {

            showCalendarYM('init', 'application', init_year, init_month, getReservationType());
            showCalendarBody('init', 'application', init_year, init_month, getReservationType());
            (document.querySelector('input[name="selected_time"]') as HTMLInputElement).value = '';
            (document.querySelector('input[name="selected_year"]') as HTMLInputElement).value = '';
            (document.querySelector('input[name="selected_month"]') as HTMLInputElement).value = '';
            (document.querySelector('input[name="selected_day"]') as HTMLInputElement).value = '';
            (document.querySelector('input[name="display_selected_time"]') as HTMLInputElement).value = '';
            (document.getElementById('selected-datetime') as HTMLSpanElement).textContent = '未設定';

            if (index === RESERVATION_REMOTE)
            {

                toggleCalendarArea(true);

            }
            else
            {

                toggleCalendarArea(false);

            }

        });

    });

}

/**
 * 墓碑画像の初期化
*/
const initTombImage = (): void =>
{

    const pictures = document.querySelectorAll('[data-tomb-image]') as NodeListOf<HTMLPictureElement>;
    pictures.forEach((picture) =>
    {

        picture.addEventListener('click', () =>
        {

            const imageTitle = document.getElementById('j-tomb-image-title') as HTMLParagraphElement;
            const image = document.getElementById('j-tomb-image') as HTMLImageElement;
            const dialog = document.getElementById('j-dialog-tomb-image') as HTMLDialogElement;
            imageTitle.innerHTML = picture.dataset.tombTitle as string;
            image.src = picture.dataset.tombImage as string;
            dialog.showModal();

        });

    });

}

/**
 * 墓碑画像の閉じるボタンの初期化
*/
const initImageClose = (): void =>
{

    const imageClose = document.getElementById('j-dialog-tomb-image-close') as HTMLButtonElement;
    if (imageClose !== null)
    {

        imageClose.addEventListener('click', () =>
        {

            const dialog = document.getElementById('j-dialog-tomb-image') as HTMLDialogElement;
            dialog.close();

            const image = document.getElementById('j-tomb-image') as HTMLImageElement;
            image.src = '';

        });

    }

}

/**
 * カレンダーの初期化
*/
const initCalendar = (): void =>
{

    const calendarYear = document.getElementById('calendar-year') as HTMLSpanElement;
    const calendarMonth = document.getElementById('calendar-month') as HTMLSpanElement;
    const calendarPrev = document.getElementById('calendar-prev') as HTMLLinkElement;
    if (calendarPrev !== null)
    {

        calendarPrev.addEventListener('click', () =>
        {

        showCalendarYM('prev', calendarPrev.dataset.mode as string, parseInt(calendarYear.textContent as string, 10), parseInt(calendarMonth.textContent as string, 10), getReservationType());
        showCalendarBody('prev', calendarPrev.dataset.mode as string, parseInt(calendarYear.textContent as string, 10), parseInt(calendarMonth.textContent as string, 10), getReservationType());

        });

    }

    const calendarNext = document.getElementById('calendar-next') as HTMLLinkElement;
    if (calendarNext !== null)
    {

        calendarNext.addEventListener('click', () =>
        {

            showCalendarYM('next', calendarNext.dataset.mode as string, parseInt(calendarYear.textContent as string, 10), parseInt(calendarMonth.textContent as string, 10), getReservationType());
            showCalendarBody('next', calendarNext.dataset.mode as string, parseInt(calendarYear.textContent as string, 10), parseInt(calendarMonth.textContent as string, 10), getReservationType());

        });

    }

}

/**
 * 時間の決定ボタンの初期化
*/
const initTimeDecision = (): void =>
{

    const timeDecision = document.getElementById('j-button-time-decision') as HTMLButtonElement;
    if (timeDecision !== null)
    {

        timeDecision.addEventListener('click', () =>
        {

            const selectedTime = document.querySelector('input[name="selected_time"]') as HTMLInputElement;
            const selectedYear = document.querySelector('input[name="selected_year"]') as HTMLInputElement;
            const selectedMonth = document.querySelector('input[name="selected_month"]') as HTMLInputElement;
            const selectedDay = document.querySelector('input[name="selected_day"]') as HTMLInputElement;
            const reservationTime = document.querySelector('input[name="reservation_time"]:checked') as HTMLInputElement;
            const selectedDatetime = document.getElementById('selected-datetime') as HTMLSpanElement;
            const displaySelectedTime = document.querySelector('input[name="display_selected_time"]') as HTMLInputElement;

            selectedTime.value = reservationTime.value;
            selectedYear.value = timeDecision.dataset.year as string;
            selectedMonth.value = timeDecision.dataset.month as string;
            selectedDay.value = timeDecision.dataset.day as string;
            selectedDatetime.textContent = timeDecision.dataset.year+'年'+timeDecision.dataset.month+'月'+timeDecision.dataset.day+'日'+' '+reservationTime?.nextSibling?.textContent;
            displaySelectedTime.value = selectedDatetime.textContent as string;

            const body = document.querySelector('body') as HTMLBodyElement;
            body.classList.toggle('u-overflow--hidden');

            const dialog = document.getElementById('j-dialog-time') as HTMLDialogElement;
            dialog.close();

        });

    }

}

/**
 * 時間のモーダルの閉じるボタンの初期化
*/
const initTimeClose = (): void =>
{

    const timeClose = document.getElementById('j-button-time-close') as HTMLButtonElement;
    timeClose.addEventListener('click', () =>
    {

        const body = document.querySelector('body') as HTMLBodyElement;
        body.classList.toggle('u-overflow--hidden');
        const dialog = document.getElementById('j-dialog-time') as HTMLDialogElement;
        dialog.close();

    });

}

/**
 * 確定ボタンの初期化
*/
const initButtonSubmit = (): void =>
{

    const buttonSubmit = document.getElementById('button-submit') as HTMLButtonElement;
    if (buttonSubmit !== null)
    {

        buttonSubmit.addEventListener('click', () =>
        {

            if (checkInput())
            {

                sendingServer();

            }

        });

    }

}

/**
 * 申込み種別のindexが0の場合の初期化
*/
const initWhenApplicationTypeIs0 = (): void =>
{

  eraseDepositingArea();
  eraseTombTypeArea();
  toggleMaterialArea(false);
  eraseMaterialArea();
  toggleFrontLetterArea(false);
  eraseFrontLetterArea();
  eraseBackLetterArea();
  toggleMemorialService(false);
  toggleDepositingArea(true);
  togglePendantArea(true);
  toggleDispersalArea(true);
  eraseDispersalArea();
  toggleKaimyouArea(true);
  eraseKaimyouArea();
}

/**
 * 申込み種別のindexが1の場合の初期化
*/
const initWhenApplicationTypeIs1 = (): void =>
{

  toggleMaterialArea(false);
  eraseTombTypeArea();
  eraseMaterialArea();
  toggleFrontLetterArea(false);
  eraseFrontLetterArea();
  eraseBackLetterArea();
  toggleDepositingArea(false);
  toggleMemorialService(false);
  togglePendantArea(false);
  toggleDispersalArea(false);
  toggleKaimyouArea(true);
  eraseKaimyouArea();
}

/**
 * 申込み種別のindexが2の場合の初期化
*/
const initWhenApplicationTypeIs2 = (): void =>
{

  toggleDepositingArea(false);
  toggleMemorialService(true);
  toggleKaimyouArea(true);
  eraseMemorialServiceArea();
  togglePendantArea(false);
  toggleDispersalArea(false);

}

/**
 * 申込み種別の初期化
*/
const initApplicationType = (): void =>
{

    const radio = document.querySelectorAll('input[name="application_type"]') as NodeListOf<HTMLInputElement>;
    if (radio !== null)
    {

        radio.forEach((radio, index) =>
        {

            radio.addEventListener('click', () =>
            {

                if (radio.checked)
                {

                  switch (index)
                  {

                      case 0:
                        initWhenApplicationTypeIs0();
                        break;
                      case 1:
                        initWhenApplicationTypeIs1();
                        break;
                      case 2:
                        initWhenApplicationTypeIs2();
                        break;
                      default:
                        break;
                  }

                  calcTotalPrice();

                }

            });

        });

    }

}

/**
 * 価格計算の対象となるラジオボタン項目の初期化
*/
const initCalcForRadio = (): void =>
{

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType) =>
        {

            tombType.addEventListener('click', () =>
            {

                calcTotalPrice();

            });

        });

    }

    const materials = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
    if (materials !== null)
    {

        materials.forEach((material) =>
        {

            material.addEventListener('click', () =>
            {

                calcTotalPrice();

            });

        });

    }

    const frontLetters = document.querySelectorAll('input[name="front_letter"]') as NodeListOf<HTMLInputElement>;
    if (frontLetters !== null)
    {

        frontLetters.forEach((letter) =>
        {

            letter.addEventListener('click', () =>
            {

                calcTotalPrice();

            });

        });

    }

}

/**
 * 価格計算の対象となるチェックボックス項目の初期化
*/
const initCalcForCheckbox = (): void =>
{

    const checkboxNames = [
        'buddhist_name1',
        'buddhist_name2',
        'buddhist_name3',
        'buddhist_name4',
        'buddhist_name5',
        'buddhist_name6',
        'buddhist_name7',
        'depositing_ashes_human_pet',
        'depositing_ashes_pet_only',
        'prenatal_application_human',
        'prenatal_application_pet',
        'pendant',
        'dispersal',
    ];

    checkboxNames.forEach((checkboxName) =>
    {

        const checkbox = document.querySelector('input[name="'+checkboxName+'"]') as HTMLInputElement;
        if (checkbox !== null)
        {

          checkbox.addEventListener('click', () =>
          {

            calcTotalPrice();

          });

        }

    });

}

/**
 * 価格計算の対象となるセレクトボックス項目の初期化
*/
const initCalcForSelect = (): void =>
{

    const selectNames = [
        'buddhist_name1_count',
        'buddhist_name2_count',
        'buddhist_name3_count',
        'buddhist_name4_count',
        'buddhist_name5_count',
        'buddhist_name6_count',
        'prenatal_application_human_count',
        'prenatal_application_pet_count',
        'pendant_count',
    ];

    selectNames.forEach((selectName) =>
    {

        const select = document.querySelector('select[name="'+selectName+'"]') as HTMLSelectElement;
        if (select !== null)
        {

          select.addEventListener('change', () =>
          {

            calcTotalPrice();

          });

        }

    });

}

/**
 * 価格計算の対象となる項目の初期化
*/
const initCalc = (): void =>
{

    initCalcForRadio();
    initCalcForCheckbox();
    initCalcForSelect();

}

/**
 * 戒名
*/
const initKaimyouArea = (): void =>
{

    const frontLetters = document.querySelectorAll('input[name="front_letter"]') as NodeListOf<HTMLInputElement>;
    const backLetters = document.querySelectorAll('input[name="back_letter"]') as NodeListOf<HTMLInputElement>;
    if (frontLetters !== null)
    {

        frontLetters.forEach((frontLetter, index) =>
        {

            frontLetter.addEventListener('change', () =>
            {

                let backLetterSelected = false;
                if (backLetters !== null)
                {

                    backLetters.forEach((backLetter, index) =>
                    {

                        if (index === 0 && backLetter.checked)
                        {

                            backLetterSelected = true;

                        }

                    });

                }

                if (frontLetter.checked)
                {

                    if (index === 2)
                    {

                        toggleKaimyouArea(false);

                    }
                    else
                    {

                        if (!backLetterSelected)
                        {

                            toggleKaimyouArea(true);
                            eraseKaimyouArea();
                            calcTotalPrice();

                        }

                    }

                }

            });

        });

    }

    if (backLetters !== null)
    {

        backLetters.forEach((backLetter, index) =>
        {

            backLetter.addEventListener('change', () =>
            {

                let frontLetterSelected = false;
                if (frontLetters !== null)
                {

                    frontLetters.forEach((frontLetter, index) =>
                    {

                        if (index === 2 && frontLetter.checked)
                        {

                            frontLetterSelected = true;

                        }

                    });

                }

                if (backLetter.checked)
                {

                    if (index === 0)
                    {

                        toggleKaimyouArea(false);

                    }
                    else
                    {

                        if (!frontLetterSelected)
                        {

                            toggleKaimyouArea(true);
                            eraseKaimyouArea();
                            calcTotalPrice();

                        }

                    }

                }

            });

        });

    }

}

/**
 * 墓種の初期化
*/
const initTombType = (): void =>
{

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType, index) =>
        {

            tombType.addEventListener('click', () =>
            {

                if (tombType.checked)
                {

                  if (index === 5)
                  {
                    toggleMaterialArea(true);
                    toggleFrontLetterArea(true);
                  }
                  else
                  {

                    toggleMaterialArea(false);
                    toggleFrontLetterArea(false);

                  }

                }

            });

        });

    }

}

/**
 * 予約選択のリセット
*/
const initButtonReset = (): void =>
{

  const button = document.getElementById('j-button-reservation-reset') as HTMLButtonElement;
  if (button !== null)
  {

    button.addEventListener('click', () =>
    {

      eraseReservationTypeArea();

    });

  }

}

/**
 * 初期化処理
*/
const init = (): void =>
{

    initCalendarDays();
    initCalendar();
    initNumberOfObjects();
    initCalc();
    initReservationType();
    initTombImage();
    initImageClose();
    initTimeDecision();
    initTimeClose();
    initButtonSubmit();
    initCheckboxSelectItems();
    initApplicationType();
    initKaimyouArea();
    initFileInput();
    initTombType();
    initButtonReset();
}

//領域の表示、非表示関係
/**
 * 戒名の領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleKaimyouArea = (isHidden: boolean): void =>
{

    const kaimyouArea = document.getElementById('j-kaimyou-area') as HTMLLIElement;

    if (isHidden)
    {

        kaimyouArea.classList.add('u-display--none');

    }
    else
    {

        kaimyouArea.classList.remove('u-display--none');

    }

}

/**
 * 納骨・供養申込み領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleDepositingArea = (isHidden: boolean): void =>
{

    const area = document.getElementById('j-depositing-area') as HTMLDivElement;
    if (isHidden)
    {

        area.classList.add('u-display--none');

    }
    else
    {

        area.classList.remove('u-display--none');

    }

}

/**
 * 材質の領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleMaterialArea = (isHidden: boolean): void =>
{

  const area = document.getElementById('j-material-area') as HTMLDivElement;
  if (isHidden)
  {

      area.classList.add('u-display--none');

  }
  else
  {

      area.classList.remove('u-display--none');

  }

}

/**
 * 表面文字領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleFrontLetterArea = (isHidden: boolean): void =>
{

    const area = document.getElementById('j-front-letter-area') as HTMLDivElement;
    if (isHidden)
    {

        area.classList.add('u-display--none');

    }
    else
    {

        area.classList.remove('u-display--none');

    }

}

/**
 * 納骨式ペンダント類領域の表示、非表示
 * @param {boolean} isHidden
*/
const togglePendantArea = (isHidden: boolean): void =>
{

  const area = document.getElementById('j-pendant-area') as HTMLDivElement;
  if (isHidden)
  {

      area.classList.add('u-display--none');

  }
  else
  {

      area.classList.remove('u-display--none');

  }

}

/**
 * 海洋散骨領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleDispersalArea = (isHidden: boolean): void =>
{

  const area = document.getElementById('j-dispersal-area') as HTMLDivElement;
  if (isHidden)
  {

      area.classList.add('u-display--none');

  }
  else
  {

      area.classList.remove('u-display--none');

  }

}

/**
 * 供養のみを選択した場合の必要領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleMemorialService = (isHidden: boolean): void =>
{

    toggleMaterialArea(isHidden);
    toggleFrontLetterArea(isHidden);

    const areaArray = [
        'j-tomb-type-area',
        'j-back-letter-area',
        'j-depositing-area',
        'j-prenatal-application-area',
        'j-object-area',
        'j-entrust-area',
        'j-introduction-area',
        'j-reservation-area',
        'j-calendar-area',
    ];

    areaArray.forEach((id) =>
    {

        const area = document.getElementById(id) as HTMLDivElement;
        if (isHidden)
        {

            area.classList.add('u-display--none');

        }
        else
        {

            area.classList.remove('u-display--none');

        }

    });

}

/**
 * カレンダー領域の表示、非表示
 * @param {boolean} isHidden
*/
const toggleCalendarArea = (isHidden: boolean): void =>
{

    const area = document.getElementById('j-calendar-area') as HTMLDivElement;
    if (isHidden)
    {

        area.classList.add('u-display--none');

    }
    else
    {

        area.classList.remove('u-display--none');

    }

}

/**
 * 予約日時が利用不可能な場合のエラーメッセージの表示
*/
const showErrorToBeUnavailable = (): boolean =>
{

    const reservationType = document.getElementsByName('reservation_type') as NodeListOf<HTMLInputElement>;
    reservationType[0].focus();
    const error = document.querySelector('span[data-error="reservation_type"]') as HTMLSpanElement;
    error.textContent = "選択した予約日時が利用不可能です。別の日時を選択してください。";
    return false;

}

/**
 * 時間のモーダルの表示
*/
const showTimeModal = (): void =>
{

    const dialog = document.getElementById('j-dialog-time') as HTMLDialogElement;
    dialog.showModal();
    const body = document.querySelector('body') as HTMLBodyElement;
    body.classList.toggle('u-overflow--hidden');
    const tableContainer = document.getElementById('j-reservation-info-wrap');
    if (tableContainer)
    {
        tableContainer.scrollLeft = 0;
    }
}

/**
 * 戒名の領域のクリア
*/
const eraseKaimyouArea = (): void =>
{

    const itemName = 'buddhist_name';
    for (let i = 1; i <= 7; i++)
    {

        const checkbox = document.querySelector('input[name="'+itemName+i+'"]') as HTMLInputElement;
        checkbox.checked = false;

        const select = document.querySelector('select[name="'+itemName+i+'_count"]') as HTMLSelectElement;
        if (select !== null)
        {

            select.selectedIndex = 0;

        }

    }

}

/**
 * 納骨・供養申込み領域のクリア
*/
const eraseDepositingArea = (): void =>
{

    const itemNames = [
        'depositing_ashes_human_pet',
        'depositing_ashes_pet_only',
    ];

    itemNames.forEach((itemName) =>
    {

        const checkbox = document.querySelector('input[name="'+itemName+'"]') as HTMLInputElement;
        checkbox.checked = false;

    });

}

/**
 * 墓種領域のクリア
*/
const eraseTombTypeArea = (): void =>
{

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType) =>
        {

            tombType.checked = false;

        });

    }

    const individualPhoto = document.getElementById('j-individual-photo') as HTMLLIElement;
    individualPhoto.classList.add('u-display--none');
    const file = document.querySelector('input[name="individual_photo"]') as HTMLInputElement;
    file.value = '';
    const explanation = document.getElementById('j-file-explanation') as HTMLSpanElement;
    explanation.classList.remove('u-display--none');


}

/**
 * 材質領域のクリア
*/
const eraseMaterialArea = (): void =>
{

    const materials = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
    if (materials !== null)
    {

        materials.forEach((material) =>
        {

            material.checked = false;

        });

    }

}

/**
 * 表面文字領域のクリア
*/
const eraseFrontLetterArea = (): void =>
{

    const frontLetters = document.querySelectorAll('input[name="front_letter"]') as NodeListOf<HTMLInputElement>;
    if (frontLetters !== null)
    {

        frontLetters.forEach((letter) =>
        {

            letter.checked = false;

        });

    }

}

/**
 * 裏面文字領域のクリア
*/
const eraseBackLetterArea = (): void =>
{

    const backLetters = document.querySelectorAll('input[name="back_letter"]') as NodeListOf<HTMLInputElement>;
    if (backLetters !== null)
    {

        backLetters.forEach((letter) =>
        {

            letter.checked = false;

        });

    }

}

/**
 * 生前申込み領域のクリア
*/
const erasePrenatalApplicationArea = (): void =>
{

    const itemNames = [
        'prenatal_application_human',
        'prenatal_application_pet',
    ];

    itemNames.forEach((itemName) =>
    {

        const checkbox = document.querySelector('input[name="'+itemName+'"]') as HTMLInputElement;
        checkbox.checked = false;

        const select = document.querySelector('select[name="'+itemName+'_count"]') as HTMLSelectElement;
        select.selectedIndex = 0;

    });

}

/**
 * 海洋散骨領域のクリア
*/
const eraseDispersalArea = (): void =>
{

  const checkbox = document.querySelector('input[name="dispersal"]') as HTMLInputElement;
  checkbox.checked = false;

}


/**
 * お墓に入る領域のクリア
*/
const eraseObjectArea = (): void =>
{

    const numberOfObject = document.querySelector('input[name="number_of_object"]') as HTMLInputElement;
    numberOfObject.value = '1';

    const totalObject = document.querySelector('input[name="total_object"]') as HTMLInputElement;
    totalObject.value = '1';

    const objectName1 = document.querySelector('input[name="object_name1"]') as HTMLInputElement;
    objectName1.value = '';

    const objectAge1 = document.querySelector('input[name="object_age1"]') as HTMLInputElement;
    objectAge1.value = '';

    const objectDeathYear1 = document.querySelector('input[name="object_death_year1"]') as HTMLInputElement;
    objectDeathYear1.value = '';

    const objectDeathMonth1 = document.querySelector('input[name="object_death_month1"]') as HTMLInputElement;
    objectDeathMonth1.value = '';

    const objectDeathDay1 = document.querySelector('input[name="object_death_day1"]') as HTMLInputElement;
    objectDeathDay1.value = '';

    const objectHobby1 = document.querySelector('textarea[name="object_hobby1"]') as HTMLTextAreaElement;
    objectHobby1.value = '';

    initNumberOfObjects();

}

/**
 * 没後委託者領域のクリア
*/
const eraseEntrustArea = (): void =>
{

    const entrustNotificationMail = document.querySelector('input[name="entrust_notification_mail"]') as HTMLInputElement;
    entrustNotificationMail.checked = false;

    const entrustName = document.querySelector('input[name="entrust_name"]') as HTMLInputElement;
    entrustName.value = '';

    const entrustKana = document.querySelector('input[name="entrust_kana"]') as HTMLInputElement;
    entrustKana.value = '';

    const entrustTel = document.querySelector('input[name="entrust_tel"]') as HTMLInputElement;
    entrustTel.value = '';

    const entrustEmail = document.querySelector('input[name="entrust_email"]') as HTMLInputElement;
    entrustEmail.value = '';

    const entrustEmailConfirmation = document.querySelector('input[name="entrust_email_confirmation"]') as HTMLInputElement;
    entrustEmailConfirmation.value = '';

    const entrustAddress = document.querySelector('input[name="entrust_address"]') as HTMLInputElement;
    entrustAddress.value = '';

    const entrustPostalCode = document.querySelector('input[name="entrust_postal_code"]') as HTMLInputElement;
    entrustPostalCode.value = '';

}

/**
 * 紹介者情報領域のクリア
*/
const eraseIntroductionArea = (): void =>
{

    const introductionName = document.querySelector('input[name="introduction_name"]') as HTMLInputElement;
    introductionName.value = '';

    const introductionTel = document.querySelector('input[name="introduction_tel"]') as HTMLInputElement;
    introductionTel.value = '';

    const introductionAddress = document.querySelector('input[name="introduction_address"]') as HTMLInputElement;
    introductionAddress.value = '';

    const introductionPostalCode = document.querySelector('input[name="introduction_postal_code"]') as HTMLInputElement;
    introductionPostalCode.value = '';

}

/**
 * 予約種別領域のクリア
*/
const eraseReservationTypeArea = (): void =>
{

    const reservationTypes = document.querySelectorAll('input[name="reservation_type"]') as NodeListOf<HTMLInputElement>;
    if (reservationTypes !== null)
    {

        reservationTypes.forEach((reservationType) =>
        {

            reservationType.checked = false;

        });

    }

}

/**
 * 供養のみを選択した場合、無関係の領域の初期化
*/
const eraseMemorialServiceArea = (): void =>
{

    eraseTombTypeArea();
    eraseMaterialArea();
    eraseFrontLetterArea();
    eraseBackLetterArea();
    eraseDepositingArea();
    erasePrenatalApplicationArea();
    eraseObjectArea();
    eraseEntrustArea();
    eraseIntroductionArea();
    eraseReservationTypeArea();
    eraseKaimyouArea();

}

/**
 * ラジオボタン項目で選択された範囲の合計金額の計算
*/
const calcTotalPriceForRadio = (): number =>
{

    let ret = 0;

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType, index) =>
        {

            if (index === 0 && tombType.checked)
            {

                ret += parseInt(tombType.dataset.price as string, 10);

            }

        });

    }

    const materials = document.querySelectorAll('input[name="material"]') as NodeListOf<HTMLInputElement>;
    if (materials !== null)
    {

        materials.forEach((material) =>
        {

            if (material.checked)
            {

                ret += parseInt(material.dataset.price as string, 10);

            }

        });

    }

    const frontLetters = document.querySelectorAll('input[name="front_letter"]') as NodeListOf<HTMLInputElement>;
    if (frontLetters !== null)
    {

        frontLetters.forEach((letter, index) =>
        {

            if (index === 1 && letter.checked)
            {

                ret += parseInt(letter.dataset.price as string, 10);

            }

        });

    }

    return ret;

}

/**
 * チェックボックス項目で選択された範囲の合計金額の計算
*/
const calcTotalPriceForCheckbox = (): number =>
{

    let ret = 0;

    const checkboxOnlyNames = [
        'depositing_ashes_human_pet',
        'depositing_ashes_pet_only',
        'dispersal',
    ];

    checkboxOnlyNames.forEach((checkboxName) =>
    {

        const checkbox = document.querySelector('input[name="'+checkboxName+'"]') as HTMLInputElement;
        if (checkbox.checked)
        {

            ret += parseInt(checkbox.dataset.price as string, 10);

        }

    });

    const checkboxWithSelectNames = [
        'buddhist_name1',
        'buddhist_name2',
        'buddhist_name3',
        'buddhist_name4',
        'buddhist_name5',
        'buddhist_name6',
        'buddhist_name7',
        'prenatal_application_human',
        'prenatal_application_pet',
        'pendant',
    ];

    checkboxWithSelectNames.forEach((checkboxName) =>
    {

        const checkbox = document.querySelector('input[name="'+checkboxName+'"]') as HTMLInputElement;
        if (checkbox.checked)
        {

            const select = document.querySelector('select[name="'+checkboxName+'_count"]') as HTMLSelectElement;
            if (select !== null && select.value !== '')
            {

                ret += parseInt(checkbox.dataset.price as string, 10)*parseInt(select.value, 10);

            }

        }

    });

    return ret;

}

/**
 * 選択した項目の合計金額の計算
*/
const calcTotalPrice = (): void =>
{

    let sum_price = 0;
    sum_price += calcTotalPriceForRadio();
    sum_price += calcTotalPriceForCheckbox();

    const total = Math.floor(sum_price*1.1);

    const totalPrice = document.querySelector('input[name="total_price"]') as HTMLInputElement;
    totalPrice.value = total.toString();

    const checkedTotalPrice = document.getElementById('checked-total-price') as HTMLSpanElement;
    checkedTotalPrice.innerHTML = total.toLocaleString();

}

/**
 * 予約可能な日にちの取得
*/
const getReservationType = (): number =>
{

    let ret = 0;
    const reservation_types = document.getElementsByName('reservation_type') as NodeListOf<HTMLInputElement>;
    reservation_types.forEach((reservation_type, index) =>
    {

        if (reservation_type.checked)
        {

            if (index !== RESERVATION_REMOTE)
            {

                ret = 1;

            }
            else
            {

                ret = 0;

            }

        }

    });

    return ret;

}


/**
 * お申込み種別の入力チェック
*/
const checkApplicationType = (): boolean =>
{

    return checkRadioTextInput('application_type');

}

/**
 * ファイルの入力チェック
*/
const checkInputFile = (): boolean =>
{

    const tombTypes = document.querySelectorAll('input[name="tomb_type"]') as NodeListOf<HTMLInputElement>;
    if (tombTypes !== null)
    {

        tombTypes.forEach((tombType, index) =>
        {

            if (index === 0 && tombType.checked)
            {

                return checkRadioTextInput('individual_photo');

            }

        });

    }

    return true;

}

const checkMakingTomb = (): boolean =>
{

  let ret = true;

  const applicationTypes = document.querySelectorAll('input[name="application_type"]') as NodeListOf<HTMLInputElement>  ;
  if (applicationTypes !== null)
  {

      applicationTypes.forEach((applicationType, index) =>
      {

        if (applicationType.checked)
        {

          if (index === 0)
          {

            if (!checkCheckboxSelectInput('prenatal_application_human', true) &&
              !checkCheckboxSelectInput('prenatal_application_pet', true))
            {

              const message = '墓石製作の場合、『生前申込み』を選択してください。';

              ret = false;
              const input = document.querySelector('input[name="prenatal_application_human"]') as HTMLInputElement;
              input.focus();

              let error = document.querySelector('span[data-error="prenatal_application_human"]') as HTMLSpanElement;
              error.textContent = message;

              error = document.querySelector('span[data-error="prenatal_application_pet"]') as HTMLSpanElement;
              error.textContent = message;

            }

          }

          if (index === 1)
          {

              const depositingAshesHumanPet = document.querySelector('input[name="depositing_ashes_human_pet"]') as HTMLInputElement;
              const depositingAshesPetOnly = document.querySelector('input[name="depositing_ashes_pet_only"]') as HTMLInputElement;

              if (!depositingAshesHumanPet.checked &&
                !depositingAshesPetOnly.checked &&
                !checkCheckboxSelectInput('prenatal_application_human', true) &&
                !checkCheckboxSelectInput('prenatal_application_pet', true))
              {

                const message = '墓石製作の場合、『納骨・開眼供養申込み』または『生前申込み』のどちらかまたは両方を選択してください。';

                ret = false;
                depositingAshesHumanPet.focus();
                let error = document.querySelector('span[data-error="depositing_ashes_human_pet"]') as HTMLSpanElement;
                error.textContent = message;

                error = document.querySelector('span[data-error="depositing_ashes_pet_only"]') as HTMLSpanElement;
                error.textContent = message;

                error = document.querySelector('span[data-error="prenatal_application_human"]') as HTMLSpanElement;
                error.textContent = message;

                error = document.querySelector('span[data-error="prenatal_application_pet"]') as HTMLSpanElement;
                error.textContent = message;

              }

          }

        }

      });

  }

  return ret;

}

/**
 * 申し込み毎の入力チェック
*/
const checkInputByApplicationType = (): boolean =>
{

    let ret = true;

    const applicationTypes = document.querySelectorAll('input[name="application_type"]') as NodeListOf<HTMLInputElement>  ;
    if (applicationTypes !== null)
    {

        applicationTypes.forEach((applicationType, index) =>
        {

          if (applicationType.checked)
          {

            if (index === 2)
            {

              ret = checkCheckboxSelectInput('pendant');

            }
            else
            {

              ret = checkRadioTextInput('tomb_type');
              if (ret)
              {

                ret = checkInputFile();
                if (ret)
                {

                  ret = checkInputAtKaiyouArea();
                  if (ret)
                  {

                    ret = checkMakingTomb();
                    if (ret)
                    {

                      ret = checkPrenatalApplicationArea();
                      if (ret)
                      {

                        ret = checkCheckboxSelectInput('pendant');

                      }

                    }

                  }

                }

              }

            }

          }

        });

    }

    return ret;

}

/**
 * 生前申込みエリアの入力チェック
*/
const checkPrenatalApplicationArea = (): boolean =>
{

    return checkCheckboxSelectInput('prenatal_application_human') && checkCheckboxSelectInput('prenatal_application_pet');

}

/**
 * 戒名エリアの入力チェック
*/
const checkSoulInput = (): boolean =>
{

    let ret = true;
    const totalObject = document.querySelector('input[name="total_object"]') as HTMLInputElement;
    const total = parseInt(totalObject.value as string, 10) || 1;

    for (let i = 1; i <= total; i++)
    {

        const object_name = document.querySelector('input[name="object_name'+i+'"]') as HTMLInputElement;
        if (object_name.value === '')
        {

            object_name.focus();
            const error = document.querySelector('span[data-error="object_name'+i+'"]') as HTMLSpanElement;
            error.textContent = '必須項目です。';
            ret = false;
            break;

        }

        const object_death_year = document.querySelector('input[name="object_death_year'+i+'"]') as HTMLInputElement;
        const object_death_month = document.querySelector('input[name="object_death_month'+i+'"]') as HTMLInputElement;
        const object_death_day = document.querySelector('input[name="object_death_day'+i+'"]') as HTMLInputElement;
        if (object_death_year.value !== '')
        {

            if (!object_death_year.checkValidity())
            {

                object_death_year.focus();
                const error = document.querySelector('span[data-error="object_death_year'+i+'"]') as HTMLSpanElement;
                error.textContent = object_death_year.validationMessage;
                ret = false;
                break;

            }

            if (object_death_month.value === '')
            {

                object_death_month.focus();
                const error = document.querySelector('span[data-error="object_death_month'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(月)を入力してください。';
                ret = false;
                break;

            }

            if (object_death_day.value === '')
            {

                object_death_day.focus();
                const error = document.querySelector('span[data-error="object_death_day'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(日)を入力してください。';
                ret = false;
                break;

            }

        }

        if (object_death_month.value !== '')
        {

            if (!object_death_month.checkValidity())
            {

                object_death_month.focus();
                const error = document.querySelector('span[data-error="object_death_month'+i+'"]') as HTMLSpanElement;
                error.textContent = object_death_month.validationMessage;
                ret = false;
                break;

            }

            if (object_death_year.value === '')
            {

                object_death_year.focus();
                const error = document.querySelector('span[data-error="object_death_year'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(年)を入力してください。';
                ret = false;
                break;

            }

            if (object_death_day.value === '')
            {

                object_death_day.focus();
                const error = document.querySelector('span[data-error="object_death_day'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(日)を入力してください。';
                ret = false;
                break;

            }

        }

        if (object_death_day.value !== '')
        {

            if (!object_death_day.checkValidity())
            {

                object_death_day.focus();
                const error = document.querySelector('span[data-error="object_death_day'+i+'"]') as HTMLSpanElement;
                error.textContent = object_death_day.validationMessage;
                ret = false;
                break;

            }

            if (object_death_year.value === '')
            {

                object_death_year.focus();
                const error = document.querySelector('span[data-error="object_death_year'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(年)を入力してください。';
                ret = false;
                break;

            }

            if (object_death_month.value === '')
            {

                object_death_month.focus();
                const error = document.querySelector('span[data-error="object_death_month'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日(月)を入力してください。';
                ret = false;
                break;

            }

        }

        if (object_death_year.value !== '' &&
            object_death_month.value !== '' &&
            object_death_day.value !== '')
        {

            const new_date = new Date(parseInt(object_death_year.value, 10),
                parseInt(object_death_month.value, 10)-1,
                parseInt(object_death_day.value, 10));

            if (new_date.getFullYear() !== parseInt(object_death_year.value, 10) ||
                new_date.getMonth() !== parseInt(object_death_month.value, 10)-1 ||
                new_date.getDate() !== parseInt(object_death_day.value, 10))
            {

                object_death_year.focus();
                const error = document.querySelector('span[data-error="object_death_year'+i+'"]') as HTMLSpanElement;
                error.textContent = '正しい命日の日付を入力してください。';
                ret = false;
                break;

            }

            if (new_date > new Date())
            {

                object_death_year.focus();
                const error = document.querySelector('span[data-error="object_death_year'+i+'"]') as HTMLSpanElement;
                error.textContent = '命日は過去の日付を入力してください。';
                ret = false;
                break;

            }

        }

    }

    return ret;

}

/**
 * チェックボックスとセレクトの組がある項目での入力チェック
*/
const checkCheckboxSelectInput = (itemName: string, isBothRequired?: boolean): boolean =>
{

    let ret = true;

    const checkbox = document.querySelector('input[name="'+itemName+'"]') as HTMLInputElement;
    const select = document.querySelector('select[name="'+itemName+'_count"]') as HTMLSelectElement;

    if (isBothRequired === undefined)
    {

      if (select !== null)
      {

        if (checkbox.checked && select.value === '')
        {

            select.focus();
            const error = document.querySelector('span[data-error="'+itemName+'_count"]') as HTMLSpanElement;
            error.textContent = select.validationMessage;
            ret = false;

        }

        if (!checkbox.checked && select.value !== '')
        {

            checkbox.focus();
            const error = document.querySelector('span[data-error="'+itemName+'"]') as HTMLSpanElement;
            error.textContent = select.validationMessage;
            ret = false;

        }

      }

    }
    else
    {

      if (select !== null)
      {

        if (!(checkbox.checked && select.value !== ''))
        {


          ret = false;

        }

      }

    }

    return ret;

}

/**
 * 開封の入力チェック
*/
const checkInputAtKaiyouArea = (): boolean =>
{

    let ret = true;

    const letterRadio = document.querySelectorAll('input[name="front_letter"]') as NodeListOf<HTMLInputElement>;
    letterRadio.forEach((radio, index) =>
    {

        if (radio.checked && index === 2)
        {

            for (let i = 1; i <= 7; i++)
            {

                if (!checkCheckboxSelectInput('buddhist_name'+i))
                {

                    ret = false;
                    break;

                }


            }

        }

    });

    return ret;

}

/**
 * 依頼者の入力チェック
*/
const checkClientArea = (): boolean =>
{

    let ret = true;

    const itemNames = [
        'applicant_name',
        'applicant_kana',
        'applicant_postal_code',
        'applicant_address',
        'applicant_tel',
        'applicant_email',
        'applicant_email_confirmation',
        'section',
    ];

    itemNames.forEach((itemName) =>
    {

        if (!checkRadioTextInput(itemName))
        {

            ret = false;

        }

    });

    if (ret)
    {

        const applicantEmail = document.querySelector('input[name="applicant_email"]') as HTMLInputElement;
        const applicantEmailConfirmation = document.querySelector('input[name="applicant_email_confirmation"]') as HTMLInputElement;
        if (applicantEmail.value !== applicantEmailConfirmation.value)
        {

            applicantEmailConfirmation.focus();
            const error = document.querySelector('span[data-error="applicant_email"]') as HTMLSpanElement;
            error.textContent = 'メールアドレスが一致しません。';
            ret = false;

        }

    }

    return ret;

}

/**
 * 墓に入る対象の霊の入力チェック
*/
const checkObjectForm = (): boolean =>
{

  let ret = true;

  const applicationTypes = document.querySelectorAll('input[name="application_type"]') as NodeListOf<HTMLInputElement>;
  if (applicationTypes !== null)
  {

    applicationTypes.forEach((applicationType, index) =>
    {

      if (index !== 2 && applicationType.checked)
      {

        if (!checkRadioTextInput('number_of_object'))
        {

            ret = false;

        }

        if (ret)
        {

          if (!checkSoulInput())
          {

            ret = false;

          }

        }

      }

    });

  }

  return ret;

}

/**
 * 没後委託者の入力チェック
*/
const checkEntrustForm = (): boolean =>
{

  let ret = true;

  const checkbox = document.querySelector('input[name="entrust_notification_mail"]') as HTMLInputElement;
  if (checkbox.checked)
  {

    const itemNames = [
      'entrust_name',
      'entrust_kana',
      'entrust_tel',
      'entrust_email',
      'entrust_email_confirmation',
      'entrust_postal_code',
      'entrust_address',
    ];

    itemNames.forEach((itemName) =>
    {

        if (!checkRadioTextInput(itemName))
        {

            ret = false;

        }

    });

    if (!ret)
    {

      const entrustEmail = document.querySelector('input[name="entrust_email"]') as HTMLInputElement;
      const entrustEmailConfirmation = document.querySelector('input[name="entrust_email_confirmation"]') as HTMLInputElement;
      if (entrustEmail.value !== entrustEmailConfirmation.value)
      {

          entrustEmailConfirmation.focus();
          const error = document.querySelector('span[data-error="entrust_email"]') as HTMLSpanElement;
          error.textContent = 'メールアドレスが一致しません。';
          ret = false;

      }

    }

  }

  return ret;

}

/**
 * 予約フォームの入力チェック
*/
const checkReservationForm = (): boolean =>
{

  let ret = true;

  const reservationTypes = document.querySelectorAll('input[name="reservation_type"]') as NodeListOf<HTMLInputElement>;
  if (reservationTypes !== null)
  {

    reservationTypes.forEach((reservationType, index) =>
    {

      if (index !== RESERVATION_REMOTE && reservationType.checked)
      {

        const selectedYear = document.querySelector('input[name="selected_year"]') as HTMLInputElement;
        if (selectedYear.value === '')
        {

            reservationType.focus();
            const error = document.querySelector('span[data-error="reservation_type"]') as HTMLSpanElement;
            error.textContent = '予約日時を選択してください。';

            ret = false;

        }

      }

    });

  }

  return ret;

}

/**
 * 来店(院)予定人数の入力チェック
*/
const checkVisitorNumber = (): boolean =>
{

    let ret = true;

    const select = document.querySelector('select[name="visitor_number"]') as HTMLSelectElement;
    if (select.value === '')
    {

        select.focus();
        const error = document.querySelector('span[data-error="visitor_number"]') as HTMLSpanElement;
        error.textContent = '必須項目です。';
        ret = false;

    }

    return ret;

}


/**
 * 入力チェック
*/
const checkInput = (): boolean =>
{

    eraseErrorMessage();

    if (!checkApplicationType())
    {

        return false;

    }

    if (!checkInputByApplicationType())
    {

        return false;

    }

    if (!checkClientArea())
    {

        return false;

    }

    if (!checkObjectForm())
    {

        return false;

    }

    if (!checkEntrustForm())
    {

        return false;

    }

    if (!checkVisitorNumber())
    {

        return false;

    }

    if (!checkReservationForm())
    {

        return false;

    }

    return true;

}

/**
 * サーバーへの送信所為
*/
const sendingServer = (): void =>
{

    let isStore = true;
    let isCheck = false;

    const reservationTypes = document.querySelectorAll('input[name="reservation_type"]') as NodeListOf<HTMLInputElement>;
    if (reservationTypes !== null)
    {

        reservationTypes.forEach((reservationType, reservationIndex) =>
        {

            if (reservationType.checked)
            {

                if (reservationIndex !== RESERVATION_REMOTE)
                {

                    isStore = false;
                    isCheck = true;

                }

            }

        });

    }
    else
    {

        isStore = true;

    }

    if (isStore)
    {

        sendServerToStore(setFormData());

    }

    if (isCheck)
    {

        sendServerToCheck();

    }

}

init();
